import React, { useEffect, useState, useCallback, useRef } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import * as RB from "react-bootstrap";
import "react-big-calendar/lib/css/react-big-calendar.css";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { MoreHoriz, Delete, Visibility, Add, Send } from "@mui/icons-material";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { fetchUserProfile } from "../../reducers/userProfileSlice";

function List(props) {
  const [requisitionList, setRequisitionList] = useState([]);
  const [show, setShow] = useState(false);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const popoverRef = useRef(null);
  const countPerPage = 10;
  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  const handleAddClick = () => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const getActionLinks = (row) => {
    const links = [];

    // Add the "View" action to the links list (View action is always allowed)
    links.push({ id: "view", name: "View", icon: <Visibility /> });

    // Add the "Edit" action only if the user has permission to edit
    if (
      utils.hasPermission(
        primaryMenuRes,
        "Sample Request",
        "sample_request.edit"
      )
    ) {
      links.push({ id: "edit", name: "Edit", icon: <EditIcon /> });
    }

    // Add the "Delete" action only if the user has permission to delete
    if (
      utils.hasPermission(
        primaryMenuRes,
        "Sample Request",
        "sample_request.delete"
      )
    ) {
      links.push({ id: "delete", name: "Delete", icon: <Delete /> });
    }

    // Add the "Send to RM" action only if the user has permission to send to RM
    if (
      utils.hasPermission(
        primaryMenuRes,
        "Sample Request",
        "sample_request.send_rm"
      )
    ) {
      links.push({ id: "send-rm", name: "Send to RM", icon: <Send /> });
    }
    const removeMenu = [];

    if (row.reporting_manager !== null) {
      // if (
      //   utils.hasPermission(
      //     primaryMenuRes,
      //     "Sample Request",
      //     "sample_request.edit"
      //   )
      // ) {
      //   removeMenu.push({ id: "edit", name: "Edit", icon: <EditIcon /> });
      // }

      // if (
      //   utils.hasPermission(
      //     primaryMenuRes,
      //     "Sample Request",
      //     "sample_request.delete"
      //   )
      // ) {
      //   removeMenu.push({ id: "delete", name: "Delete", icon: <Delete /> });
      // }

      // if (
      //   !utils.hasPermission(
      //     primaryMenuRes,
      //     "Sample Request",
      //     "sample_request.send_rm"
      //   )
      // ) {
      //   removeMenu.push({ id: "send-rm", name: "Send to RM", icon: <Send /> });
      // }

      removeMenu.push(
        { id: "edit", name: "Edit", icon: <EditIcon /> },
        { id: "delete", name: "Delete", icon: <Delete /> },
        { id: "send-rm", name: "Send to RM", icon: <Send /> }
      );
    }

    const removeMenuIds = removeMenu.map((menu) => menu.id);

    const myLinks = links.filter((link) => !removeMenuIds.includes(link.id));

    return myLinks;
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/requisitionDelete?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              getRequisition();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handelSendRm = useCallback((row) => async () => {
    if (popoverRef.current) {
      popoverRef.current.click(); // Trigger the overlay to close
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You want to send this to your Reporting Manager!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/send_requisition_to_rm?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              getRequisition();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const getActionOnClick = (id, row) => {
    switch (id) {
      case "view":
        handleView(row)();
        break;
      case "edit":
        handelEdit(row)();
        break;
      case "send-rm":
        handelSendRm(row)();
        break;
      case "delete":
        showDelete(row)();

      default:
        break;
    }
  };

  const columns = [
    {
      name: "Sr.No",
      selector: (row, index) => (page - 1) * countPerPage + index + 1,
      sortable: false,
      maxWidth: "80px", // Adjust the maximum width as needed
      minWidth: "60px",
      center: true,
    },
    {
      name: "Date",
      selector: (row) => moment(row.date).format("DD-MM-yyyy"),
    },
    {
      name: <div>Name</div>,
      selector: (row) => row.team_member_name,
      // cell: (row) => <div className="text-center">{row.quarter_1}</div>,
    },
    {
      name: <div>Channel Partner</div>,
      selector: (row) => row.channel_partner?.companyName || "N/A",
    },
    {
      name: <div>Products</div>,
      selector: (row) => (row.products ? row?.products?.length : ""),
      center: true,
    },
    {
      name: (
        <div class="text-center">
          Reqd
          <br />
          Qty
        </div>
      ),
      selector: (row) => row.total_qty,
      center: true,
    },
    {
      name: (
        <div class="text-center">
          Qty
          <br />
          Kg.
        </div>
      ),
      selector: (row) => row.total_qty_kg,
      center: true,
    },
    {
      name: <div class="text-center">Status</div>,
      selector: (row) => row.status,
      center: true,
    },

    {
      name: "Action",
      center: true,
      cell: (row) => {
        return (
          <>
            <RB.OverlayTrigger
              trigger="click"
              rootClose
              key="bottom"
              placement="bottom"
              overlay={
                <RB.Popover id={`popover-positioned-bottom`}>
                  <RB.Popover.Body className="p-0">
                    <div className="list-group">
                      {getActionLinks(row).map((link) => (
                        <>
                          <Link
                            to={"#"}
                            className="list-group-item list-group-item-action"
                            onClick={(e) => {
                              e.preventDefault();
                              getActionOnClick(link.id, row);
                            }}
                          >
                            {link.icon} {link.name}
                          </Link>
                        </>
                      ))}
                    </div>
                  </RB.Popover.Body>
                </RB.Popover>
              }
              ref={popoverRef}
            >
              <RB.Button
                className="btn-circle"
                variant="outline-secondary"
                size="sm"
                onClick={() => setShow(!show)}
              >
                <MoreHoriz />
              </RB.Button>
            </RB.OverlayTrigger>
          </>
        );
      },
    },
  ];

  const getRequisition = () => {
    utils
      .callAPI(
        "get",
        `/sales/getRequisitionList?per_page=${countPerPage}&page=${page}&id=${""}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setRequisitionList(res);
        } else {
          setRequisitionList([]);
        }
      })
      .catch((err) => {
        setRequisitionList([]);
      });
  };

  useEffect(() => {
    getRequisition();
  }, []);

  return (
    <div className="section-body">
      <RB.Card className="">
        <RB.Card.Header>
          <h4>List Sample Request</h4>

          {utils.hasPermission(
            primaryMenuRes,
            "Sample Request",
            "sample_request.create"
          ) && (
            <div className="card-header-action mt-0 ms-0 ms-md-auto">
              <RB.Button
                className="btn btn-primary me-md-2"
                onClick={handleAddClick}
              >
                Create Sample Request
              </RB.Button>
            </div>
          )}
        </RB.Card.Header>
        <RB.Card.Body>
          {/*{utils.hasPermission(primaryMenuRes, "Holiday", "holiday.view") && (
            <div className="custom-calendar">
              <Calendar
                localizer={localizer}
                events={holidayList}
                startAccessor="start"
                endAccessor="end"
                style={{ height: "500px" }}
                views={["month", "week", "day"]}
                //   defaultView="month"
                //   eventPropGetter={eventStyleGetter}
                onSelectEvent={(event) => console.log(event)}
              />
            </div>
          )}*/}

          {utils.hasPermission(
            primaryMenuRes,
            "Sample Request",
            "sample_request.view"
          ) && (
            <DataTable
              columns={columns}
              data={requisitionList.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={requisitionList.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              // subHeader
              // subHeaderComponent={subHeaderComponent}
            />
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
